const styles = theme => ({
	root: {
		fontFamily: theme.typography.fontFamily,
	},
	
});

export default styles;